import { QaiSimulationSettingLabels, QaiSimulationSettingOption } from '@qai/ui';
import { ComplianceScoreImpactEnum } from '../../enums/self-serve/compliance-score-impact.enum';

/** Value used when a simulation link has no saved setting (null). */
export const DEFAULT_COMPLIANCE_SCORE_IMPACT = ComplianceScoreImpactEnum.BLOCKING_WITH_FEEDBACK;

export function resolveComplianceScoreImpact(
  value: ComplianceScoreImpactEnum | null | undefined,
): ComplianceScoreImpactEnum {
  return value ?? DEFAULT_COMPLIANCE_SCORE_IMPACT;
}

/**
 * Whether a results page shows the other feedback when the call is out of compliance.
 * With COMPLIANCE_SCORE_IMPACT off, results keep today's behaviour (feedback hidden).
 * ADVISORY ("Normal scoring") is not offered yet, so it keeps feedback hidden too.
 */
export function showsFeedbackWhenOutOfCompliance(
  value: ComplianceScoreImpactEnum | null | undefined,
  flagEnabled: boolean,
): boolean {
  return flagEnabled && resolveComplianceScoreImpact(value) === ComplianceScoreImpactEnum.BLOCKING_WITH_FEEDBACK;
}

/** Whether an out-of-compliance call uses the "Compliance only" setting, so its results say no score was given. */
export function isComplianceOnly(
  value: ComplianceScoreImpactEnum | null | undefined,
  flagEnabled: boolean,
): boolean {
  return flagEnabled && resolveComplianceScoreImpact(value) === ComplianceScoreImpactEnum.BLOCKING_NO_FEEDBACK;
}

export function buildComplianceScoreImpactOptions(
  translate: (key: string) => string,
): QaiSimulationSettingOption[] {
  return [
    {
      value: ComplianceScoreImpactEnum.BLOCKING_NO_FEEDBACK,
      label: translate('simulationBuilder.COMPLIANCE_SCORE_COMPLIANCE_ONLY'),
      tooltip: translate('simulationBuilder.COMPLIANCE_SCORE_COMPLIANCE_ONLY_TOOLTIP'),
    },
    {
      value: ComplianceScoreImpactEnum.BLOCKING_WITH_FEEDBACK,
      label: translate('simulationBuilder.COMPLIANCE_SCORE_INCLUDE_FEEDBACK'),
      tooltip: translate('simulationBuilder.COMPLIANCE_SCORE_INCLUDE_FEEDBACK_TOOLTIP'),
    },
  ];
}

export function buildComplianceScoreImpactLabels(
  translate: (key: string) => string,
): QaiSimulationSettingLabels {
  return {
    label: translate('simulationBuilder.COMPLIANCE_SCORE_LABEL'),
    helpLabel: translate('simulationBuilder.COMPLIANCE_SCORE_HELP_LABEL'),
    description: translate('simulationBuilder.COMPLIANCE_SCORE_DESCRIPTION'),
    tooltipIntro: translate('simulationBuilder.COMPLIANCE_SCORE_TOOLTIP_INTRO'),
    tooltipFooter: translate('simulationBuilder.COMPLIANCE_SCORE_TOOLTIP_FOOTER'),
  };
}
